<template>
  <div>
    <div v-if="hasECG" class="action-menu-item" @click="downloadECG">
      <span v-if="loading" class="spinner-border spinner-border-sm"></span
      >{{ $t('src/components/training/downloadecg.3194') }}
    </div>
    <base-modal :is-show="isShowModal" mode="ok" @close="closeModal" @cancel="closeModal">
      <template #header>{{ $t('src/components/training/downloadecg.9813') }}</template>
      <template #body>
        {{ downloadMessage }}
      </template>
    </base-modal>
  </div>
</template>

<script>
import http from '@/modules/http'
const moment = require('moment')
import { userRights } from '@/mixins/user-rights.js'

export default {
  name: 'DownloadECG',
  components: {
    BaseModal: () => import('@/base/BaseModal.vue')
  },
  mixins: [userRights],
  props: {
    ecg: {
      type: [String, null],
      required: true
    },
    trainingId: {
      type: Number,
      required: true
    },
    courseId: {
      type: Number,
      required: true
    },
    patient: {
      type: Object,
      required: true
    },
    dateStart: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: false,
    fileNotFound: false,
    isShowModal: false,
    downloadMessage: ''
  }),
  computed: {
    hasECG() {
      return !!this.ecg
    },
    isS3() {
      if (!this.hasECG) {
        return false
      }
      return this.ecg.substr(0, 3) === 'S3_'
    }
  },
  methods: {
    downloadECG() {
      this.loading = true
      if (this.isS3) {
        this.downloadFromS3()
          .then(url => {
            this.goToLink(url)
          })
          .catch(error => {
            if (error === 'NotFound') {
              this.downloadMessage = this.$t('src/components/training/downloadecg.fileNotFound')
            } else if (error == 404) {
              this.downloadMessage = `${this.$t('src/components/training/downloadecg.noSessionWithID')} ${
                this.trainingId
              }`
            } else if (error === 'NoPrefix') {
              this.downloadMessage = `${this.$t('src/components/training/downloadecg.noPrefix')}`
            } else if (error === 'Empty') {
              this.downloadMessage = `${this.$t('src/components/training/downloadecg.empty')}`
            }
            this.showModal()
          })
      } else {
        this.downLoadFromFileSystem()
          .then(url => {
            this.goToLink(url)
          })
          .catch(error => {
            if (error.response.status === 404) {
              this.downloadMessage = `${this.$t('src/components/training/downloadecg.fileNotFound')}`
              this.showModal()
            } else {
              console.error(error)
            }
          })
      }
    },
    goToLink(url) {
      let name = `ecg_record_`
      if (this.isNeuroAdmin) {
        name += `course-${this.courseId}_training-${this.trainingId}_`
      } else
        name += `${this.trainingId}_${this.patient.surname}_${this.patient.name}_${this.patient.middle_name}_`
      name += `${moment
        .utc(this.dateStart)
        .local()
        .format('DD-MM-YYYY_HH-mm')}.edf`
      const link = document.createElement('a')
      link.className = 'hidden'
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)

      link.click()
      link.remove()
    },
    downloadFromS3() {
      return new Promise((resolve, reject) => {
        http
          .get('/ecg-upload-s3/' + this.trainingId)
          .then(response => {
            if (response.data.Code === 'OK') {
              resolve(response.data.URL)
            } else {
              reject(response.data.Code)
            }
          })
          .catch(error => {
            if (error.response.data.Code) {
              reject(error.response.data.Code)
            } else {
              reject(error)
            }
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    downLoadFromFileSystem() {
      return new Promise((resolve, reject) => {
        http
          .get('/ecg-upload/' + this.ecg, {
            headers: {
              Accept: 'application/octet-stream',
              'Cache-Control': 'no-cache'
            },
            responseType: 'blob'
          })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            resolve(url)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    showModal() {
      this.isShowModal = true
    },
    closeModal() {
      this.isShowModal = false
    }
  }
}
</script>
